import _ from "lodash";
import moment from "moment";
import { Point3D, MathLib } from "./3D";
const { ShotScore } = require("../../../dualuse/aig/modules/score/score");
const shotScore = new ShotScore();

// import DataProDetailJSON from "./data-pro-detail.json";

let DataProDetail = {};

let methods = [
	"AIGIA標準メソッド",
	"0000_AIGIA_Method",
	"0001_HOYU_Method",
	"0002_HOYU_Method(Real)",
];

let pros = [
	"0001_Koiwai_Style",
	"0002_Matsuyama_Style",
	"0003_AdamScott_Style",
	"0004_Maruyama_Style",
	"0005_TigerWoods_Style",
	"0006_Yonekura_Style",
	"0007_RoryMcilroy_Style",
	"0008_FrueAyaka_Style",
	"0009_XanderSchauffele_Style",
	"0010_Fleetwood_Style",
];

let ReferenceData = {
	DataPro: null,
	DataProDetail: null,
	RuleData: null,
	DisplayParts: null,
	ballistic: false,
	fake_advice: "",
};
let RuleData = null;

let ruleData = {};

let mapData = (x) => {
	let tmp: any = {};
	tmp = {
		frameNo: x["#frameNo"],
		...x,
	};

	tmp.SpineBase = {
		x: tmp.SpineBase_x,
		y: tmp.SpineBase_y,
		z: tmp.SpineBase_z,
	};
	tmp.SpineMid = { x: tmp.SpineMid_x, y: tmp.SpineMid_y, z: tmp.SpineMid_z };
	tmp.Neck = { x: tmp.Neck_x, y: tmp.Neck_y, z: tmp.Neck_z };
	tmp.Head = { x: tmp.Head_x, y: tmp.Head_y, z: tmp.Head_z };
	tmp.ShoulderLeft = {
		x: tmp.ShoulderLeft_x,
		y: tmp.ShoulderLeft_y,
		z: tmp.ShoulderLeft_x,
	};
	tmp.ElbowLeft = {
		x: tmp.ElbowLeft_x,
		y: tmp.ElbowLeft_y,
		z: tmp.ElbowLeft_z,
	};
	tmp.WristLeft = {
		x: tmp.WristLeft_x,
		y: tmp.WristLeft_y,
		z: tmp.WristLeft_z,
	};
	tmp.HandLeft = { x: tmp.HandLeft_x, y: tmp.HandLeft_y, z: tmp.HandLeft_z };
	tmp.ShoulderRight = {
		x: tmp.ShoulderRight_x,
		y: tmp.ShoulderRight_y,
		z: tmp.ShoulderRight_z,
	};
	tmp.ElbowRight = {
		x: tmp.ElbowRight_x,
		y: tmp.ElbowRight_y,
		z: tmp.ElbowRight_z,
	};
	tmp.WristRight = {
		x: tmp.WristRight_x,
		y: tmp.WristRight_y,
		z: tmp.WristRight_z,
	};
	tmp.HandRight = {
		x: tmp.HandRight_x,
		y: tmp.HandRight_y,
		z: tmp.HandRight_z,
	};
	tmp.HipLeft = { x: tmp.HipLeft_x, y: tmp.HipLeft_y, z: tmp.HipLeft_z };
	tmp.KneeLeft = { x: tmp.KneeLeft_x, y: tmp.KneeLeft_y, z: tmp.KneeLeft_z };
	tmp.AnkleLeft = {
		x: tmp.AnkleLeft_x,
		y: tmp.AnkleLeft_y,
		z: tmp.AnkleLeft_z,
	};
	tmp.FootLeft = { x: tmp.FootLeft_x, y: tmp.FootLeft_y, z: tmp.FootLeft_z };
	tmp.HipRight = { x: tmp.HipRight_x, y: tmp.HipRight_y, z: tmp.HipRight_z };
	tmp.KneeRight = {
		x: tmp.KneeRight_x,
		y: tmp.KneeRight_y,
		z: tmp.KneeRight_z,
	};
	tmp.AnkleRight = {
		x: tmp.AnkleRight_x,
		y: tmp.AnkleRight_y,
		z: tmp.AnkleRight_z,
	};
	tmp.FootRight = {
		x: tmp.FootRight_x,
		y: tmp.FootRight_y,
		z: tmp.FootRight_z,
	};
	tmp.SpineShould = {
		x: tmp.SpineShould_x,
		y: tmp.SpineShould_y,
		z: tmp.SpineShould_z,
	};
	tmp.SpineShoulder = {
		x: tmp.SpineShould_x,
		y: tmp.SpineShould_y,
		z: tmp.SpineShould_z,
	};
	tmp.HandTipLeft = {
		x: tmp.HandTipLeft_x,
		y: tmp.HandTipLeft_y,
		z: tmp.HandTipLeft_z,
	};
	tmp.ThumbLeft = {
		x: tmp.ThumbLeft_x,
		y: tmp.ThumbLeft_y,
		z: tmp.ThumbLeft_z,
	};
	tmp.HandTipRight = {
		x: tmp.HandTipRight_x,
		y: tmp.HandTipRight_y,
		z: tmp.HandTipRight_z,
	};
	tmp.ThumbRight = {
		x: tmp.ThumbRight_x,
		y: tmp.ThumbRight_y,
		z: tmp.ThumbRight_z,
	};
	return tmp;
};

let ProPhases = {
	"0001_Koiwai_Style": {
		address: 10,
		backswing: 72,
		top: 130,
		halfdown: 183,
		impact: 189,
		follow: 197,
		finish: 223,
	},
	"0002_Matsuyama_Style": {
		address: 5,
		backswing: 57,
		top: 107,
		halfdown: 155,
		impact: 159,
		follow: 165,
		finish: 177,
	},
	"0003_AdamScott_Style": {
		address: 30,
		backswing: 98,
		top: 185,
		halfdown: 264,
		impact: 277,
		follow: 295,
		finish: 321,
	},
	"0004_Maruyama_Style": {
		address: 16,
		backswing: 36,
		top: 48,
		halfdown: 56,
		impact: 58,
		follow: 60,
		finish: 66,
	},
	"0005_TigerWoods_Style": {
		address: 30,
		backswing: 98,
		top: 169,
		halfdown: 235,
		impact: 247,
		follow: 261,
		finish: 287,
	},
	"0006_Yonekura_Style": {
		address: 30,
		backswing: 62,
		top: 82,
		halfdown: 96,
		impact: 98,
		follow: 102,
		finish: 116,
	},
	"0007_RoryMcilroy_Style": {
		address: 29,
		backswing: 97,
		top: 184,
		halfdown: 250,
		impact: 261,
		follow: 275,
		finish: 301,
	},
	"0008_FrueAyaka_Style": {
		address: 30,
		backswing: 90,
		top: 148,
		halfdown: 202,
		impact: 211,
		follow: 216,
		finish: 228,
	},
	"0009_XanderSchauffele_Style": {
		address: 29,
		backswing: 67,
		top: 117,
		halfdown: 143,
		impact: 148,
		follow: 155,
		finish: 159,
	},
	"0010_Fleetwood_Style": {
		address: 21,
		backswing: 89,
		top: 150,
		halfdown: 213,
		impact: 224,
		follow: 232,
		finish: 254, // 258,
	},
};

function getProDriverPhase(proName) {
	return ProPhases[proName];
}

const calculateProPhase = () => {
	let output = {};
	let frameData = {};
	Object.keys(ProPhases).forEach((k, idx) => {
		let result = getProDriverPhase(k);
		output[k] = result;

		// frameData[k] = {};
		// Object.keys(result).forEach((x) => {
		// 	frameData[k][x] = DataPro[k][result[x] - 1];
		// 	console.log("stop here");
		// });

		// console.log("stop here");
	});

	ReferenceData = {
		...ReferenceData,
		DataPro: output,
		DataProDetail,
	};
};

calculateProPhase();

const calculateRuleData = () => {
	let output = {};
	let phases = [
		"address",
		"backswing",
		"top",
		"halfdown",
		"impact",
		"follow",
		"finish",
	];
	Object.keys(ruleData).forEach((method) => {
		output[method] = {
			method,
		};
		let fields = [
			"advice_template",
			"mesure_model",
			"mesure_model_5wood",
			"mesure_model_7iron",
			"mesure_model_pw",
			"score_rule",
			"score_rule2",
			"score_rule2_pw",
			"score_rule2_5w",
			"score_rule2_7i",
			"diagnose_rule",
			"ballistic_scorerule",
			"ballistic_scorerule_7iron",
			"reference_model",
			"diagnose_rule2",
			"digitallesson_advice",
			"score_explanation",
		];
		fields.forEach((f) => {
			let raw = ruleData[method][f] || "";
			let maxMark = 0;
			let prevParam4, prevParam5;
			switch (f) {
				case "advice_template":
					output[method][f] = raw;
					break;
				case "mesure_model":
				case "mesure_model_5wood":
				case "mesure_model_7iron":
				case "mesure_model_pw":
					output[method][f] = raw
						.replace(/\r/g, "")
						.split("\n")
						.map((x) => x.trim())
						.filter((x) => x && x[0] != "#")
						.map((x) => x.split(","))
						.filter((x) => x.length > 1)
						.map((x, idx) => {
							let data = x;
							let result = {
								idx,
								part: data[0],
								is_ballistic: false,
								calculate_type: Number(data[1]),
								formular_type: Number(data[1])
									? Number(data[2])
									: data[2],
								params: data.slice(3),
							};

							return result;
						});

					break;
				case "score_rule":
				case "score_rule2":
				case "score_rule2_pw":
				case "score_rule2_5w":
				case "score_rule2_7i":
					output[method][f] = raw
						.replace(/\r/g, "")
						.split("\n")
						.map((x) => x.trim())
						.filter((x) => x && x[0] != "#")
						.map((x) => x.split(","))
						.filter((x) => x.length > 1)
						.map((x, idx) => {
							let data = x;

							let param4 = Number(data[3]);
							let param5 = Number(data[4]);

							let markAlpha = data[1];
							if (markAlpha == "A") {
								prevParam4 = param4;
								prevParam5 = param5;
							}

							if (_.isNaN(param4) || _.isNaN(param5)) {
								param4 = prevParam4;
								param5 = prevParam5;
							}

							let result = {
								idx,
								part: data[0],
								mark_alpha: markAlpha,
								mark_number: Number(data[2]),
								param4,
								param5,
								rule: [],
								max_mark: 0,
							};
							if (result.mark_alpha == "A") {
								maxMark = result.mark_number;
							}
							result.max_mark = maxMark;

							for (let i = 0; i < (data.length - 5) / 3; i++) {
								result.rule.push({
									phase: Number(data[5 + i * 3]),
									min_value: Number(data[5 + i * 3 + 1]),
									max_value: Number(data[5 + i * 3 + 2]),
								});
							}

							return result;
						});

					output[method][f]
						.filter((x) => x.mark_alpha == "other")
						.forEach((x) => {
							output[method][f]
								.filter((y) => y.part == x.part)
								.forEach((y) => {
									y.min_mark = x.mark_number;
									y.field = f;
								});
						});

					if (f == "score_rule") {
						let partGroup = _.groupBy(output[method][f], "part");
						let graphScope = [];
						Object.keys(partGroup).forEach((part) => {
							let data = partGroup[part];
							let scope = {};
							data.forEach((d) => {
								if (d.rule)
									d.rule.forEach((r) => {
										scope[phases[r.phase]] = {
											min: r.min_value,
											max: r.max_value,
											param4: d.param4,
											param5: d.param5,
										};
									});
							});

							phases.forEach((p, pIdx) => {
								if (_.isEmpty(scope[p])) {
									let valuePhase = phases.find(
										(x, idx) =>
											idx < pIdx && !_.isEmpty(scope[x])
									);
									if (!valuePhase) {
										valuePhase = phases.find(
											(x, idx) =>
												idx > pIdx &&
												!_.isEmpty(scope[x])
										);
									}
									scope[p] = JSON.parse(
										JSON.stringify(scope[valuePhase])
									);
								}
							});

							graphScope.push({
								part,
								field: f,
								scope: _.pick(scope, phases),
							});
						});
						output[method]["graph_scope"] = graphScope;
					}

					break;

				case "ballistic_scorerule":
				case "ballistic_scorerule_7iron":
					output[method][f] = raw
						.replace(/\r/g, "")
						.split("\n")
						.map((x) => x.trim())
						.filter((x) => x && x[0] != "#")
						.map((x) => x.split(","))
						.filter((x) => x.length > 1)
						.map((x, idx) => {
							let data = x;

							let result = {
								idx,
								part: data[0],
								mark_alpha: data[1],
								mark_number: Number(data[2]),
								rule:
									data.length > 3
										? [
												{
													min_value: Number(data[3]),
													max_value: Number(data[4]),
												},
										  ]
										: null,
								max_mark: 0,
							};
							if (result.mark_alpha == "A") {
								maxMark = result.mark_number;
							}
							result.max_mark = maxMark;

							return result;
						});

					output[method][f]
						.filter((x) => x.mark_alpha == "other")
						.forEach((x) => {
							output[method][f]
								.filter((y) => y.part == x.part)
								.forEach((y) => {
									y.min_mark = x.mark_number;
								});
						});

					break;

				case "diagnose_rule":
				case "diagnose_rule2":
					output[method][f] = raw
						.replace(/\r/g, "")
						.split("\n")
						.map((x) => x.trim())
						.filter((x) => x && x[0] != "#")
						.map((x) => x.split(","))
						.filter((x) => x.length > 1)
						.map((x, idx) => {
							let data = x;

							let compareType = Number(data[4]);

							let result = {
								idx,
								part: data[0],
								phase: Number(data[1]),
								mark_alpha: data[2],
								sign: data[3],
								phase_2: null,
								mark_alpha_2: null,
								sign_2: null,
								advice: data[4],
								video: data[5],
								advice_map: data[6],
							};

							if (data.length > 5) {
								result.phase_2 = Number(data[4]);
								result.mark_alpha_2 = data[5];
								result.sign_2 = data[6];
								result.advice = data[7];
								result.video = data[8];
								result.advice_map = data[9];
							}

							return result;
						});
					break;

				case "reference_model":
					output[method][f] = raw
						.replace(/\r/g, "")
						.split("\n")
						.map((x) => x.trim())
						.map((x) => {
							let data = x.split(",");

							return {
								part: data[0],
								address: Number(data[1]),
								backswing: Number(data[2]),
								top: Number(data[3]),
								halfdown: Number(data[4]),
								impact: Number(data[5]),
								follow: Number(data[6]),
								finish: Number(data[7]),
							};
						});
					break;
				case "digitallesson_advice":
					var lines = raw
						.replace(/\r/g, "")
						.split("\n")
						.map((x) => x.trim())
						.filter((x) => x && x[0] != "#");
					var groups = [];
					var newItem = null;
					for (let i = 0; i < lines.length; i++) {
						const line = lines[i];
						var isNewGroup = /\d{3}/.test(line.substr(0, 3));
						if (isNewGroup) {
							newItem = {
								code: line.slice(0, 3),
								template: [line.slice(4)],
							};

							groups.push(newItem);
						} else if (newItem) {
							newItem.template.push(line);
						}
					}
					output[method][f] = groups.map((x) => ({
						...x,
						// template: x.template.join("\n"),
					}));
					break;
				case "score_explanation":
					var lines = raw
						.replace(/\r/g, "")
						.split("\n")
						.map((x) => x.trim())
						.filter((x) => x && x[0] != "#");
					var groups = [];
					var newItem = null;
					for (let i = 0; i < lines.length; i++) {
						const line = lines[i];
						var [part, adviceCode] = line.split(",");
						var isNewGroup =
							part &&
							adviceCode &&
							output[method].mesure_model.find(
								(x) => x.part == part
							) &&
							Number(adviceCode) >= 0;
						if (isNewGroup) {
							newItem = {
								part: part,
								code: adviceCode,
								template: [
									line.slice(
										[part, adviceCode].join(",").length + 1
									),
								],
							};
							groups.push(newItem);
						} else if (newItem) {
							newItem.template.push(line);
						}
					}
					output[method][f] = groups.map((x) => ({
						...x,
						// template: x.template.join("\n"),
					}));
					break;

				default:
					break;
			}
		});
	});
	// fs.writeFileSync(__dirname + "/rules.json", JSON.stringify(output), "utf8");
	// console.log("done, wrote result to", __dirname + "/rules.json");
	ReferenceData = {
		...ReferenceData,
		RuleData: output,
	};

	RuleData = ReferenceData.RuleData;

	// console.log("ReferenceData", ReferenceData);
};
calculateRuleData();

let missingRuleMap = {
	ミート率: "ミート率",
	バックスピン: "バックスピン",
	"打ち出し角(上下)": "打ち出し角 上下",
	サイドスピン: "サイドスピン",
	"打ち出し角(左右)": "打ち出し角 左右",
	左右ブレ: "左右ブレ",
	飛距離: "トータル",
	ヘッドスピード: "ヘッドスピード",
};

let fnCalculatePartByMesure = ({
	input,
	methodData,
	proData,
	csvData,
	user,
}) => {
	let mesureModel = methodData.mesure_model;
	let club = _.get(input, "platform.description.club") || 1;
	let scoreRule = methodData.score_rule;

	let scoreRule2 =
		{
			1: methodData.score_rule2,
			3: methodData.score_rule2_5w,
			10: methodData.score_rule2_7i,
			13: methodData.score_rule2_pw,
		}[club] || methodData.score_rule2;

	let diagnoseRule = methodData.diagnose_rule;
	let diagnoseRule2 = methodData.diagnose_rule2;
	let referenceModel = methodData.reference_model;
	let graphScopeData = methodData.graph_scope;
	let result = {};
	let temp = {};
	let temp2 = {};
	let userData = {};

	let isCalculateDelta = mesureModel[0].calculate_type == 1;
	let isStandardAIGIA = methodData.method == "AIGIA標準メソッド";
	let scoreAIGIAStdOrigin = null;
	let scoreAIGIAStd = {};
	if (isStandardAIGIA) {
		switch (club) {
			case 1:
				scoreAIGIAStdOrigin = shotScore.postureScoreOf1W(
					input.sm,
					true
				);
				break;
			case 3:
				scoreAIGIAStdOrigin = shotScore.postureScoreOf5W(
					input.sm,
					true
				);
				break;
			case 10:
				scoreAIGIAStdOrigin = shotScore.postureScoreOf7I(
					input.sm,
					true
				);
				break;
			case 13:
				scoreAIGIAStdOrigin = shotScore.postureScoreOfPW(
					input.sm,
					true
				);
				break;
			default:
				scoreAIGIAStdOrigin = shotScore.postureScoreOf1W(
					input.sm,
					true
				);
				break;
		}
	}
	if (isCalculateDelta) {
		let phases = {
			address: _.get(input, ["sm", "前傾角度", "address", "frame"]),
			backswing: _.get(input, ["sm", "前傾角度", "backswing", "frame"]),
			top: _.get(input, ["sm", "前傾角度", "top", "frame"]),
			halfdown: _.get(input, ["sm", "前傾角度", "halfdown", "frame"]),
			impact: _.get(input, ["sm", "前傾角度", "impact", "frame"]),
			follow: _.get(input, ["sm", "前傾角度", "follow", "frame"]),
			finish: _.get(input, ["sm", "前傾角度", "finish", "frame"]),
		};
		Object.keys(phases).forEach((k) => {
			userData[k] = csvData[phases[k] - 1];
		});
	}

	let ballisticRules =
		{
			1: methodData.ballistic_scorerule,
			10: methodData.ballistic_scorerule_7iron,
		}[club] || methodData.ballistic_scorerule;

	Object.keys(missingRuleMap).forEach((k, idx) => {
		let data = _.get(input, "prizm.DataList", []).find(
			(x) => x.Name == missingRuleMap[k]
		);

		if (data) {
			result[k] = {
				is_missing_rule: true,
				metrics: _.get(data, "Value", 0),
				unit: _.get(data, "Unit", ""),
				detail: data,
				part: k,
			};

			result[k].rule = ballisticRules.find(
				(x) =>
					x.part == k &&
					(!x.rule ||
						(x.rule &&
							result[k].metrics >= x.rule[0].min_value &&
							result[k].metrics <= x.rule[0].max_value))
			);
			if (!result[k].rule) {
				// console.log("not found rule", k);
			}
		}
	});
	for (let i = 0; i < mesureModel.length; i++) {
		const mesure = mesureModel[i];
		if (mesure.calculate_type == 0) {
			let data = input.sm[mesure.formular_type];

			if (isStandardAIGIA) {
				Object.keys(data).forEach((f) => {
					data[f].metrics = Math.round(data[f].metrics);
				});

				scoreAIGIAStd[mesure.part] =
					scoreAIGIAStdOrigin[mesure.formular_type];

				scoreAIGIAStd[mesure.part].part = mesure.part;
				let max_mark = _.get(
					_.maxBy(scoreAIGIAStd[mesure.part].rules, "mark_number"),
					"mark_number"
				);
				let min_mark = _.get(
					_.minBy(scoreAIGIAStd[mesure.part].rules, "mark_number"),
					"mark_number"
				);

				scoreAIGIAStd[mesure.part].rules.forEach((x) => {
					x.max_mark = max_mark;
					x.min_mark = min_mark;
					x.part = mesure.part;
					x.is_aigia_standard = true;
				});
			}
			temp[mesure.part] = {
				mesure: mesure,
				user: data,
				user_origin: JSON.parse(JSON.stringify(data)),
				part: mesure.part,
			};
		} else if (mesure.calculate_type == 1) {
			let pro = fnCalculateMesureData(mesure, input, proData);
			let user = fnCalculateMesureData(mesure, input, userData);

			temp[mesure.part] = {
				mesure: mesure,
				user_origin: JSON.parse(JSON.stringify(user)),
				pro_origin: JSON.parse(JSON.stringify(pro)),
				pro,
				user,
				part: mesure.part,
			};
		}
	}

	// calculate score rule

	let tempParts = Object.keys(temp);
	tempParts.forEach((part) => {
		let phases = [
			"address",
			"backswing",
			"top",
			"halfdown",
			"impact",
			"follow",
			"finish",
		];

		if (
			["0000_AIGIA_Method", "AIGIA標準メソッド"].indexOf(
				methodData.method
			) > -1 &&
			!temp[part].pro
		) {
			let refData = methodData.reference_model.find(
				(x) => x.part == part
			);
			if (refData) {
				temp[part].pro = {};
				temp[part].pro_origin = {};

				phases.forEach((phase) => {
					temp[part].pro[phase] = {
						metrics: refData[phase],
						sign: "",
						unit: temp[part].user[phase].unit,
					};
					temp[part].pro_origin[phase] = {
						metrics: refData[phase],
						sign: "",
						unit: temp[part].user[phase].unit,
					};
				});
			}
		}

		let { user, pro, user_origin, pro_origin } = temp[part];

		let data = user_origin;

		let partRules = scoreRule.filter((x) => x.part == part);
		let partRules2 = scoreRule2.filter((x) => x.part == part);

		if (isStandardAIGIA) {
			partRules = scoreAIGIAStd[part].rules;
		}

		let [rule, rule2] = [partRules, partRules2].map((prs, idxPr) => {
			return prs.find((x, prIdx) => {
				let tempPartData = null;
				if (idxPr) {
					tempPartData = JSON.parse(
						JSON.stringify(temp2[part] || temp[part])
					);
					temp2[part] = tempPartData;
				} else {
					tempPartData = JSON.parse(JSON.stringify(temp[part]));
					temp[part] = tempPartData;
				}

				let detail = {};
				phases.forEach((p) => {
					let metrics = data[p].metrics;
					let metrics0 = data[p].metrics;

					let isKeepAbsolute = data[p].unit == "°";

					if (isStandardAIGIA && idxPr == 0) {
						tempPartData.user[p].metrics0 =
							tempPartData.user_origin[p].metrics;
						metrics = tempPartData.user_origin[p].metrics;
						metrics0 = metrics;
					} else {
						switch (x.param4) {
							case 0:
								if (user_origin) {
									tempPartData.user[p].metrics =
										tempPartData.user_origin[p].metrics -
										tempPartData.user_origin["address"]
											.metrics;

									if (isKeepAbsolute) {
										tempPartData.user[p].metrics0 =
											tempPartData.user_origin[p].metrics;
									} else {
										tempPartData.user[p].metrics0 =
											tempPartData.user[p].metrics;
									}

									tempPartData.user[p].sign =
										tempPartData.user[p].sign >= 0 ? 1 : -1;
								}
								if (pro_origin) {
									tempPartData.pro[p].metrics =
										tempPartData.pro_origin[p].metrics -
										tempPartData.pro_origin["address"]
											.metrics;

									if (isKeepAbsolute) {
										tempPartData.pro[p].metrics0 =
											tempPartData.pro_origin[p].metrics;
									} else {
										tempPartData.pro[p].metrics0 =
											tempPartData.pro[p].metrics;
									}

									tempPartData.pro[p].sign =
										tempPartData.pro[p].sign >= 0 ? 1 : -1;
								}

								metrics =
									tempPartData.user[p].metrics -
									tempPartData.user["address"].metrics;
								if (isKeepAbsolute) {
									metrics0 = tempPartData.user[p].metrics0;
								} else {
									metrics0 = metrics;
								}

								break;
							case -1:
								metrics = data[p].metrics;
								metrics0 = data[p].metrics;

								if (user_origin) {
									tempPartData.user[p].metrics0 =
										tempPartData.user_origin[p].metrics;
									tempPartData.user[p].metrics =
										tempPartData.user_origin[p].metrics;
									tempPartData.user[p].sign =
										tempPartData.user[p].sign >= 0 ? 1 : -1;
								}
								if (pro_origin) {
									tempPartData.pro[p].metrics0 =
										tempPartData.pro_origin[p].metrics;
									tempPartData.pro[p].metrics =
										tempPartData.pro_origin[p].metrics;
									tempPartData.pro[p].sign =
										tempPartData.pro[p].sign >= 0 ? 1 : -1;
								}
								break;
							default:
								break;
						}

						switch (x.param5) {
							case 0:
								// metrics = temp[part].user[p].metrics;
								break;
							case 1:
								metrics =
									tempPartData.user[p].metrics -
									tempPartData.pro[p].metrics;
								metrics0 = metrics;

								break;
							default:
								break;
						}
					}

					if (isStandardAIGIA) {
						metrics = Math.round(metrics);
					}

					detail[p] = {
						metrics,
						metrics0,
						unit: tempPartData.user
							? tempPartData.user[p].unit
							: data[p].unit,
						sign: metrics >= 0 ? 1 : -1,
					};
				});

				let pass = false;

				if (isStandardAIGIA && idxPr == 0) {
					pass =
						scoreAIGIAStd[x.part].score.mark_alpha == x.mark_alpha;
					if (pass) {
						let lineData = [x.part];
						phases.forEach((p, pIdx) => {
							lineData[pIdx + 1] = {
								metrics: detail[p].metrics0,
							};
						});
						phases.forEach((p, pIdx) => {
							let score = scoreAIGIAStd[x.part].score;
							let isError = shotScore.is_error_cell(
								club,
								lineData,
								pIdx + 1,
								""
							);
							if (isError) {
								score = scoreAIGIAStd[x.part].rules.find(
									(x) => x.mark_alpha == "other"
								);
							}
							detail[p] = {
								...detail[p],
								..._.pick(x, [
									"mark_alpha",
									"mark_number",
									"min_mark",
									"max_mark",
								]),
								...score,
								rule: x,
							};
						});
					}
					tempPartData.detail = detail;
				} else {
					pass = !_.some(x.rule, (r) => {
						let val = detail[phases[r.phase]].metrics;
						return val < r.min_value || val > r.max_value;
					});

					if (pass) {
						// calculate phase mark
						let phaseHasMarks = _(prs)
							.map((x) => x.rule)
							.flatten()
							.map((x) => x.phase)
							.uniq()
							.value();

						phases.forEach((p, idx) => {
							let pIdx = idx;
							if (phaseHasMarks.indexOf(pIdx) == -1) return;

							let phaseRule = prs.find(
								(pr) =>
									pr.rule.find(
										(r) =>
											r.phase == pIdx &&
											detail[p].metrics >= r.min_value &&
											detail[p].metrics <= r.max_value
									) || !pr.rule.length
							);

							detail[p] = {
								...detail[p],
								..._.pick(phaseRule, [
									"mark_alpha",
									"mark_number",
									"min_mark",
									"max_mark",
								]),
								rule: phaseRule,
							};
						});
						tempPartData.detail = detail;
					}
				}

				return pass;
			});
		});

		// if (part == "前傾ライン") {
		// 	console.log("debug1", "前傾ライン", rule, "data", temp[part]);
		// }

		temp[part].rule = rule;
		if (temp2[part]) temp2[part].rule = rule2;

		// if (!rule) {
		// 	console.log("part", part, "not found rule");
		// }

		// calculate graph scope
		let graphScope = {};
		try {
			let scopeData = graphScopeData.find((x) => x.part == part);
			let scope = scopeData.scope;
			let partData = temp[scopeData.part];
			phases.forEach((p, idx) => {
				let scopePhase = scope[p];
				let minValue = scopePhase.min;
				let maxValue = scopePhase.max;

				graphScope[p] = {
					part: part,
					phase: p,
					min: minValue,
					max: maxValue,
				};

				// if (isStandardAIGIA) {
				// 	let point = partData.user;
				// 	const AD = Math.round(point.address.metrics0 * 1);

				// 	let phaseName = [
				// 		["address", "AD"],
				// 		["backswing", "HB"],
				// 		["top", "TP"],
				// 		["halfdown", "HD"],
				// 		["impact", "IM"],
				// 		["follow", "HF"],
				// 		["finish", "FN"],
				// 	].find((x) => x[0] == p);

				// 	let range = range_par_phase(scopeData.part, phaseName[1], AD, club);

				// 	graphScope[p] = {
				// 		...graphScope[p],
				// 		...range,
				// 	};

				// 	console.log("override range", p, "minValue", minValue, range.min, "maxValue", maxValue, range.max);
				// }
			});
		} catch (error) {
			// console.log("not found scope", part);
		}

		temp[part].graph_scope = graphScope;
		let realValues = [
			...phases.map((p) => temp[part].user[p].metrics),
			...phases
				.map((p) => _.get(temp[part], ["pro", p, "metrics"], null))
				.filter((x) => x != null),
			...(methodData.method.indexOf("AIGIA") > -1
				? Object.keys(graphScope).map(
						(p) => (graphScope[p].min + graphScope[p].max) / 2
				  )
				: []),
		];

		let graphScopeRealMax = _.max([
			...Object.keys(graphScope).map((p) => graphScope[p].max),
			...realValues,
		]);
		let graphScopeRealMin = _.min([
			...Object.keys(graphScope).map((p) => graphScope[p].min),
			...realValues,
		]);
		temp[part].graph_scope_real_max = graphScopeRealMax;
		temp[part].graph_scope_real_min = graphScopeRealMin;

		temp[part].graph_scope_max = graphScopeRealMax + 10;
		temp[part].graph_scope_min = graphScopeRealMin - 10;

		result[part] = temp[part];
	});

	// calculate diagnose rule
	let allDiagnose = isStandardAIGIA
		? []
		: diagnoseRule.filter((x) => {
				let partData = temp[x.part];
				if (partData) {
					let { detail } = partData;
					if (detail) {
						let phases = Object.keys(partData.detail);
						if (
							(partData.detail[phases[x.phase]].mark_alpha ||
								"other") == x.mark_alpha &&
							(!x.mark_alpha_2 ||
								(partData.detail[phases[x.phase_2]]
									.mark_alpha || "other") == x.mark_alpha_2)
						) {
							let phases = Object.keys(partData.detail);

							let sign = {
								1: "+",
								"-1": "-",
							}[partData.detail[phases[x.phase]].sign];

							if (!sign) {
								sign =
									partData.detail[phases[x.phase]].metrics > 0
										? "+"
										: "-";
							}

							if (x.sign_2) {
								let sign2 = {
									1: "+",
									"-1": "-",
								}[partData.detail[phases[x.phase_2]].sign];

								if (!sign2)
									sign2 =
										partData.detail[phases[x.phase_2]]
											.metrics > 0
											? "+"
											: "-";
								if (sign2 == x.sign_2 && sign == x.sign) {
									return true;
								}
							} else {
								if (!x.sign) {
									return true;
								}
								if (sign == x.sign) {
									return true;
								}
							}
						}
					}
				} else {
					// console.log("not exist part", x.part);
				}

				return false;
		  });

	let allDiagnose2 = diagnoseRule2.filter((x) => {
		let partData = temp2[x.part];
		if (partData) {
			let { detail } = partData;
			if (detail) {
				let phases = Object.keys(partData.detail);
				if (
					partData.detail[phases[x.phase]].mark_alpha ==
						x.mark_alpha &&
					(!x.mark_alpha_2 ||
						partData.detail[phases[x.phase_2]].mark_alpha ==
							x.mark_alpha_2)
				) {
					let phases = Object.keys(partData.detail);

					let sign = {
						1: "+",
						"-1": "-",
					}[partData.detail[phases[x.phase]].sign];

					if (x.sign_2) {
						let sign2 = {
							1: "+",
							"-1": "-",
						}[partData.detail[phases[x.phase_2]].sign];

						if (
							(!x.sign_2 || sign2 == x.sign_2) &&
							(!x.sign || sign == x.sign)
						) {
							return true;
						}
					} else {
						return !x.sign || sign == x.sign;
					}
				} else {
				}
			}
		} else {
			// console.log("not exist part", x.part);
		}

		return false;
	});

	if (!allDiagnose.length && !isStandardAIGIA) {
		allDiagnose = [
			{
				idx: diagnoseRule.length,
				part: "",
				phase: 0,
				mark_alpha: "",
				sign: "",
				phase_2: 0,
				mark_alpha_2: "",
				sign_2: "",
				advice: "ナイススイング",
			},
		];
	}

	// fake data
	let isFakeDiagnose2 = !!ReferenceData.fake_advice;
	if (isFakeDiagnose2) {
		allDiagnose2 = [
			"前傾ライン",
			"センターポジション",
			"センターライン",
		].map((x, idx) =>
			diagnoseRule2.find(
				(y) =>
					y.part == x &&
					y.advice_map == ReferenceData.fake_advice[idx]
			)
		);
	}

	allDiagnose = _.uniqBy(allDiagnose, "part");
	allDiagnose2 = _.uniqBy(allDiagnose2, "part");

	let firstDiagnose = _.first(allDiagnose);

	allDiagnose.forEach((d, idx) => {
		if (d && temp[d.part]) {
			temp[d.part].diagnose = d;
			temp[d.part].first_diagnose = idx == 0;
		}
	});

	allDiagnose2.forEach((d, idx) => {
		if (d && temp[d.part]) {
			temp[d.part].diagnose2 = d;
			temp[d.part].first_diagnose2 = idx == 0;
		}
	});

	let adviceInfo = ["前傾ライン", "センターポジション", "センターライン"].map(
		(x) => ({
			part: x,
			code: _.get(temp, [x, "diagnose2", "advice_map"]) || "9",
		})
	);

	let advicePartCode = adviceInfo.map((x) => x.code).join("");

	let templateAdviceInfo = methodData.digitallesson_advice.find(
		(x) => x.code == advicePartCode
	);

	// console.log(
	// 	"templateAdviceInfo",
	// 	templateAdviceInfo,
	// 	"advicePartCode",
	// 	advicePartCode
	// );

	let regexKey = /%(.*?)%/gm;

	let partsDiagnose2 = [
		"前傾ライン",
		"センターポジション",
		"センターライン",
	].map((x) => allDiagnose2.find((y) => y && y.part == x));

	// console.log("partsDiagnose2", partsDiagnose2);

	let allTemplateAdvice = methodData.digitallesson_advice.filter(
		(x) => x.code == advicePartCode
	);
	if (!allTemplateAdvice.length) {
		allTemplateAdvice = [
			methodData.digitallesson_advice.find((x) => x.code == "999"),
		];
	}

	allTemplateAdvice = allTemplateAdvice
		.map((x) => ({ ...x, template: x.template.join("\n") }))
		.map((x) => {
			let templateDetail = _(adviceInfo)
				.map((x) =>
					methodData.score_explanation.find(
						(y) => y.part == x.part && y.code == x.code
					)
				)
				.filter((x) => x)
				.map((x) => x.template)
				.flattenDeep()
				.join("\n");

			x.template_origin = x.template;

			let videoPath = "";
			[x.template, videoPath] = x.template.split(",,");
			x.template = x.template.replace(
				new RegExp(`%score_explanation%`, "g"),
				templateDetail
			);
			let keys = _(x.template.match(regexKey))
				.map((x) => x.replace(/\%/g, ""))
				.uniq()
				.sort()
				.value();
			let adviceContentDisplay = x.template;
			let adviceContentConsole = x.template;
			let adviceContent = x.template;

			for (let i = 0; i < keys.length; i++) {
				const key = keys[i];
				let keyData = key.split("_");
				let value = "";
				switch (keyData[0]) {
					// ===== %user% =====
					case "user":
						value =
							_.get(
								user,
								"content.nickname",
								_.get(user, "username", "")
							) || "";

						// console.log("value", key);
						// console.log('date', moment(input.modify).format("YYYY/MM/DD HH:mm:ss"))
						break;

					// ===== %video_path% =====
					case "video":
						if (key == "video_path") {
							value = videoPath;
						}
						break;

					// ===== %date% =====
					case "date":
						value = moment(input.modify).format(
							"YYYY/MM/DD HH:mm:ss"
						);

						break;

					// ===== %part_1% =====
					case "part":
						var partName = {
							1: "前傾ライン",
							2: "センターポジション",
							3: "センターライン",
						}[keyData[1]];
						value = partName;

						break;

					// ===== %ad_value_1%, %ad_value_1_2% =====
					case "ad":
						var partDiagnose2 =
							partsDiagnose2[Number(keyData[2]) - 1];

						var partData = temp2[partDiagnose2.part];
						// var partRefData = referenceModel.find(
						// 	(y) => y.part == partDiagnose2.part
						// );

						// var phaseIdx = partDiagnose2.phase;
						var phaseIdx = 0;
						if (keyData[3]) {
							// ===== %ad_value_1_2% =====
							phaseIdx = Number(keyData[3]);
						}
						var phaseName = {
							0: "address",
							1: "backswing",
							2: "top",
							3: "halfdown",
							4: "impact",
							5: "follow",
							6: "finish",
						}[phaseIdx];
						// var refValue = _.round(partRefData[phaseName], 2);
						var userValue = _.round(
							partData.user[phaseName].metrics0,
							2
						);

						var unit = partData.user[phaseName].unit || "";
						value = `${userValue}${unit}`.trim();

						break;
					// ===== %value_1%, %value_1_2% =====
					case "value":
						var partDiagnose2 =
							partsDiagnose2[Number(keyData[1]) - 1];

						var partData = temp2[partDiagnose2.part];
						var partRefData = referenceModel.find(
							(y) => y.part == partDiagnose2.part
						);

						var phaseIdx = 0;
						if (keyData[2]) {
							// ===== %value_1_2% =====
							phaseIdx =
								partDiagnose2[
									`phase` +
										(keyData[2] == "1"
											? ""
											: `_${keyData[2]}`)
								];
						}
						var phaseName = {
							0: "address",
							1: "backswing",
							2: "top",
							3: "halfdown",
							4: "impact",
							5: "follow",
							6: "finish",
						}[phaseIdx];
						// var refValue = _.round(partRefData[phaseName], 2);
						var userValue = _.round(
							partData.detail[phaseName].metrics,
							2
						);

						var unit = partData.detail[phaseName].unit || "";
						value = `${userValue}${unit}`.trim();

						break;

					// ===== %phase_1_1%, %phase_diff_1%, %phase_diff_1_2% =====
					case "phase":
						if (keyData[1] == "diff") {
							// ===== %phase_diff_1% =====
							var partDiagnose2 =
								partsDiagnose2[Number(keyData[2]) - 1];
							var partData = temp2[partDiagnose2.part];
							var partRefData = referenceModel.find(
								(y) => y.part == partDiagnose2.part
							);

							var phaseIdx: number = partDiagnose2.phase;
							if (keyData[3]) {
								// ===== %phase_diff_1_2% =====
								phaseIdx =
									partDiagnose2[
										`phase` +
											(keyData[3] == "1"
												? ""
												: `_${keyData[3]}`)
									];
							}
							var phaseName = {
								0: "address",
								1: "backswing",
								2: "top",
								3: "halfdown",
								4: "impact",
								5: "follow",
								6: "finish",
							}[phaseIdx];
							var partValue = partData.detail[phaseName].metrics0;

							var refValue = Number(partRefData[phaseName]);

							value = `${_.round(partValue - refValue, 2)}${
								partData.detail[phaseName].unit || ""
							}`.trim();
						}
						// ===== %phase_1_1% =====
						else {
							var partDiagnose2 =
								partsDiagnose2[Number(keyData[1]) - 1];
							var partData = temp2[partDiagnose2.part];
							var phaseIdx: number = partDiagnose2.phase;
							if (keyData[2]) {
								// ===== %phase_1_1% =====
								phaseIdx =
									partDiagnose2[
										`phase` +
											(keyData[2] == "1"
												? ""
												: `_${keyData[2]}`)
									];
							}
							value =
								{
									0: "アドレス", // "address",
									1: "ハーフバック", // "backswing",
									2: "トップ", // "top",
									3: "ハーフダウン", // "halfdown",
									4: "インパクト", // "impact",
									5: "ハーフフォロー", // "follow",
									6: "フィニッシュ", // "finish",
								}[phaseIdx] || "";
						}

						break;

					// ===== %threshold_1%, %threshold_1_2% =====
					case "threshold":
						var partDiagnose2 =
							partsDiagnose2[Number(keyData[1]) - 1];
						if (!partDiagnose2) {
							// console.log(
							// 	"key",
							// 	key,
							// 	"not found partDiagnose2",
							// 	partsDiagnose2
							// );
							break;
						}
						var phaseIdx: number = partDiagnose2.phase;
						if (keyData[2]) {
							// ===== %threshold_1_2% =====
							phaseIdx =
								partDiagnose2[
									`phase` +
										(keyData[2] == "1"
											? ""
											: `_${keyData[2]}`)
								];
						}
						var partData = temp2[partDiagnose2.part];
						// var partRefData = referenceModel.find(
						// 	(y) => y.part == partDiagnose2.part
						// );
						var phaseName = {
							0: "address",
							1: "backswing",
							2: "top",
							3: "halfdown",
							4: "impact",
							5: "follow",
							6: "finish",
						}[phaseIdx];
						var partValue = partData.detail[phaseName].metrics;

						// var refValue = Number(partRefData[phaseName]);

						// var diff = _.round(partValue - refValue, 2);

						var partScoreRules = scoreRule2.filter(
							(y) => y.part == partDiagnose2.part
						);
						var bestScoreRule = partScoreRules.find(
							(y) => y.mark_alpha == "A"
						);
						if (keyData[2]) {
							// ===== %threshold_1_2% =====
							phaseIdx =
								partDiagnose2[
									`phase` +
										(keyData[2] == "1"
											? ""
											: `_${keyData[2]}`)
								];
						}
						value = "";
						var threshold = bestScoreRule.rule.find(
							(y) => y.phase == phaseIdx
						);
						if (threshold) {
							value = `${
								partValue < 0
									? threshold.min_value
									: threshold.max_value
							} ${partData.detail[phaseName].unit || ""}`.trim();
						}

						break;

					default:
						break;
				}

				adviceContentDisplay = adviceContentDisplay.replace(
					new RegExp(`%${key}%`, "g"),
					`<span class="red font-bold">${
						value || key + "_empty"
					}</span>(<span class="blue">%${key}%</span>)`
				);
				const Reset = "\x1b[0m";
				const Bright = "\x1b[1m";
				const Dim = "\x1b[2m";
				const Underscore = "\x1b[4m";
				const Blink = "\x1b[5m";
				const Reverse = "\x1b[7m";
				const Hidden = "\x1b[8m";

				const FgBlack = "\x1b[30m";
				const FgRed = "\x1b[31m";
				const FgGreen = "\x1b[32m";
				const FgYellow = "\x1b[33m";
				const FgBlue = "\x1b[34m";
				const FgMagenta = "\x1b[35m";
				const FgCyan = "\x1b[36m";
				const FgWhite = "\x1b[37m";

				const BgBlack = "\x1b[40m";
				const BgRed = "\x1b[41m";
				const BgGreen = "\x1b[42m";
				const BgYellow = "\x1b[43m";
				const BgBlue = "\x1b[44m";
				const BgMagenta = "\x1b[45m";
				const BgCyan = "\x1b[46m";
				const BgWhite = "\x1b[47m";
				adviceContentConsole = adviceContentConsole.replace(
					new RegExp(`%${key}%`, "g"),
					`${FgRed}${
						value || key + "_empty"
					}${Reset}(${FgBlue}%${key}%${Reset})`
				);
				adviceContent = adviceContent.replace(
					new RegExp(`%${key}%`, "g"),
					`${value || key + "_empty"}`
				);
			}

			if (x.code != "666") {
				adviceContent = methodData.advice_template.replace(
					"%ai_advice%",
					adviceContent
				);
				adviceContentDisplay = methodData.advice_template.replace(
					"%ai_advice%",
					adviceContentDisplay
				);
				adviceContentConsole = methodData.advice_template.replace(
					"%ai_advice%",
					adviceContentConsole
				);
			}

			return {
				code: x.code,
				template: x.template,
				adviceContent,
				adviceContentDisplay,
				adviceContentConsole,
				videoPath,
				isFakeDiagnose2,
				is_static: keys.length == 0,
			};
		});

	return {
		result,
		temp,
		temp2,
		allDiagnose,
		firstDiagnose,
		advicePartCode,
		templateAdviceInfo,
		allTemplateAdvice,
		// allDiagnose2,
		// firstDiagnose2,
	};
};

let fnCalculateMesureData = (mesure, input, proData) => {
	let output = {};
	let phaseList = Object.keys(proData);
	phaseList.forEach((phase) => {
		let phaseData = proData[phase];
		let { params } = mesure;

		try {
			let p1,
				p2,
				p3,
				v,
				value,
				sign = 1,
				axis,
				mf,
				formular,
				unit;
			switch (mesure.formular_type) {
				case 1:
					// { "part": "前傾ライン", "calculate_type": 1, "formular_type": 1, "params": ["SpineBase", "SpineShoulder", "yz", "y", "value"] }

					// if (mesure.part == "前傾ライン") {
					// 	console.log("stop here");
					// }

					unit = "°";
					// p1 = new Point3D(
					// 	phaseData[params[0] + "_x"],
					// 	phaseData[params[0] + "_y"],
					// 	phaseData[params[0] + "_z"]
					// );
					// p2 = new Point3D(
					// 	phaseData[params[1] + "_x"],
					// 	phaseData[params[1] + "_y"],
					// 	phaseData[params[1] + "_z"]
					// );
					p1 = new Point3D(
						phaseData[params[0]].x,
						phaseData[params[0]].y,
						phaseData[params[0]].z
					);
					p2 = new Point3D(
						phaseData[params[1]].x,
						phaseData[params[1]].y,
						phaseData[params[1]].z
					);

					mf = "xyz"
						.split("")
						.find((x) => params[2].indexOf(x) == -1);
					p1[mf] = 0;
					p2[mf] = 0;

					axis = params.length == 5 ? params[3] : "y";

					v = {
						x: new Point3D(1, 0, 0),
						y: new Point3D(0, 1, 0),
						z: new Point3D(0, 0, 1),
					}[axis];
					p3 = p1.add(v);
					value = MathLib.angleBetweenVectors(p1, p2, p3);

					if (
						(axis == "y" && p1.x < p2.x) ||
						(axis == "x" && p1.y < p2.y)
					) {
						value = -value;
						sign = -1;
					}

					formular = _.last(params);
					value = eval(formular);

					break;
				case 4:
					// {
					// 	"part": "センターポジション",
					// 	"calculate_type": 1,
					// 	"formular_type": 4,
					// 	"params": ["SpineBase", "xy", "x", "value"]
					// }
					unit = "cm";
					// p2 = new Point3D(
					// 	phaseData[params[0] + "_x"],
					// 	phaseData[params[0] + "_y"],
					// 	phaseData[params[0] + "_z"]
					// );

					p2 = new Point3D(
						phaseData[params[0]].x,
						phaseData[params[0]].y,
						phaseData[params[0]].z
					);

					axis = params.length == 4 ? params[2] : "y";

					p1 = new Point3D(0, 0, 0);

					value = p2[axis] * 100;

					formular = _.last(params);
					value = eval(formular);

					sign = value >= 0 ? 1 : -1;

					break;

				case 3:
					// {"idx":7,"part":"右膝の角度(後方)","is_ballistic":false,"calculate_type":1,"formular_type":3,"params":["AnkleRight","KneeRight","HipRight","yz","180-value"]}

					unit = "°";
					// p1 = new Point3D(
					// 	phaseData[params[1] + "_x"],
					// 	phaseData[params[1] + "_y"],
					// 	phaseData[params[1] + "_z"]
					// );
					// p2 = new Point3D(
					// 	phaseData[params[0] + "_x"],
					// 	phaseData[params[0] + "_y"],
					// 	phaseData[params[0] + "_z"]
					// );
					// p3 = new Point3D(
					// 	phaseData[params[2] + "_x"],
					// 	phaseData[params[2] + "_y"],
					// 	phaseData[params[2] + "_z"]
					// );

					p1 = new Point3D(
						phaseData[params[1]].x,
						phaseData[params[1]].y,
						phaseData[params[1]].z
					);
					p2 = new Point3D(
						phaseData[params[0]].x,
						phaseData[params[0]].y,
						phaseData[params[0]].z
					);
					p3 = new Point3D(
						phaseData[params[2]].x,
						phaseData[params[2]].y,
						phaseData[params[2]].z
					);

					mf = "xyz"
						.split("")
						.find((x) => params[3].indexOf(x) == -1);
					p1[mf] = 0;
					p2[mf] = 0;
					p3[mf] = 0;

					value = MathLib.angleBetweenVectors(p1, p2, p3);

					formular = _.last(params);
					value = eval(formular);

					sign = Math.sign(value);
					break;
				default:
					break;
			}

			output[phase] = {
				metrics: value,
				sign,
				unit,
				axis,
			};
		} catch (error) {
			// console.log("mesure error", mesure, "phase", phase, "error", error);
		}
	});

	return output;
};

const calculatePartByMesure = ({ method, input, pro, csvData, user }) => {
	if (_.get(input, "calculated_data")) {
		console.log("[EXIST calculated_data] calculatePartByMesure use calculated data instead of calculating by method");

		return {
			...input.calculated_data,
			input: _.omit(input, 'calculated_data')
		};
	} else {
		console.log("[NOT_EXIST calculated_data] calculatePartByMesure calculating by method");
	}

	let isStandardAIGIA = method == "AIGIA標準メソッド";
	let input2 = JSON.parse(JSON.stringify(input));
	let result = null;
	// switch (method) {
	// 	case "0001_HOYU_Method":
	// 	case "0002_HOYU_Method(Real)":
	// 		result = fnCalculatePartByMesure({
	// 			input,
	// 			methodData: RuleData[method],
	// 			proData: DataProDetail[pro],
	// 			csvData,
	// 		});
	// 		break;
	// 	case "0000_AIGIA_Method":
	// 	case "AIGIA標準メソッド":
	// 		result = fnCalculatePartByMesure({
	// 			input,
	// 			methodData: RuleData[method],
	// 			proData: null,
	// 			csvData: null,
	// 		});
	// 		break;

	// 	default:
	// 		break;
	// }

	result = {
		...fnCalculatePartByMesure({
			input: input2,
			methodData: RuleData[method],
			proData: DataProDetail[pro],
			csvData,
			user,
		}),
		user,
		input: input2,
		pro,
		method,
		missingRuleMap,
		displayParts: ReferenceData.DisplayParts,
	};

	let parts = _(_.get(result, "temp", {}))
		.toArray()
		.sortBy((x) => _.get(x, "mesure.idx"))
		.value();

	result.parts = parts;

	result.club = { 1: "1W", 3: "5W", 13: "PW", 10: "7I" }[
		result.input.platform.description.club
	];
	result.name_version = result.input.create
		.substr(0, 16)
		.replace("T", " ")
		.replace(/\-/g, ".");

	result.missing_rule_parts = Object.keys(result.missingRuleMap).map((x) => ({
		part: x,
		...result.result[x],
	}));

	// calculate value
	let roundDecimal = 3;

	parts.forEach((part) => {
		let totalScore = 0;
		let maxScore = 0;
		let phases = Object.keys(part.detail);
		let countOther = 0;
		phases.forEach((p) => {
			let phaseData = part.detail[p];
			if (phaseData.rule) {
				totalScore += phaseData.mark_number;
				maxScore += phaseData.max_mark;

				if (phaseData.mark_alpha == "other") {
					countOther += 1;
				}
			}
		});

		let maxRadarChartMark = 5;

		if (isStandardAIGIA) {
			// part.total_score = _.round(part.rule.mark_number, 1);
			// part.max_score = _.round(part.rule.max_mark, 1);

			maxScore = 6;
			totalScore = maxScore - countOther;
			maxRadarChartMark = 6;
		}

		part.total_score = _.round(totalScore, 1);
		part.max_score = _.round(maxScore, 1);

		part.score_5 = _.round((totalScore / maxScore) * maxRadarChartMark, 1);
	});

	result.totalSwingScore =
		_.round(
			(_.sumBy(parts, (x) => _.get(x, "total_score", 0)) /
				_.sumBy(parts, (x) => _.get(x, "max_score", 0))) *
				100,
			roundDecimal
		) || 0;
	result.totalBallScore =
		_.round(
			(_.sumBy(result.missing_rule_parts, (x) =>
				_.get(x, "rule.mark_number", 0)
			) /
				_.sumBy(result.missing_rule_parts, (x) =>
					_.get(x, "rule.max_mark", 0)
				)) *
				100,
			roundDecimal
		) || 0;

	// if (isStandardAIGIA) {
	// 	result.totalSwingScore = shotScore.postureScore(input);
	// 	result.totalBallScore = shotScore.ballisticScore(input);
	// }

	if (!ReferenceData.ballistic) {
		result.totalScore = _.round(result.totalSwingScore, roundDecimal);
		[result.totalScoreNumber, result.totalScoreDecimal] = result.totalScore
			.toFixed(3)
			.split(".");

		result.totalBallScore = 0;

		result.swingScore = Math.floor(result.totalSwingScore);
		result.ballScore = Math.floor(result.totalBallScore);
	} else {
		result.totalScore = _.round(
			(result.totalSwingScore + result.totalBallScore) / 2,
			roundDecimal
		);

		[result.totalScoreNumber, result.totalScoreDecimal] = result.totalScore
			.toFixed(3)
			.split(".");

		result.swingScore = Math.floor(result.totalSwingScore / 2);
		result.ballScore = Math.floor(result.totalBallScore / 2);
	}

	result.totalScoreFloor = Math.floor(result.totalScore);

	let reports = result.parts.map((x) => {
		let row = {
			part: x.part,
		};

		[
			"address",
			"backswing",
			"top",
			"halfdown",
			"impact",
			"follow",
			"finish",
		].forEach((phase) => {
			row[phase] = x.detail[phase].metrics;
		});
		return row;
	});
	console.table(reports);
	console.log(_.get(result, "allTemplateAdvice[0].adviceContentConsole", ""));

	return result;
};

let smParts = [
	"前傾角度",
	"背骨の傾き",
	"首元の動き",
	"右腰の動き",
	"左腰の動き",
	"重心の動き_正面",
	"右膝の角度",
	"手元の浮き",
	"左膝の角度",
	"頭の動き",
	"両肩の傾き_正面",
	"重心の動き_後方",
	"グリップ位置",
	"手首軌道",
	"腰の開き",
	"肩の開き",
];

let avgParts = {};
let avgPartsMap = {};
let avgPartsReverseMap = {};

const updateModel = (data) => {
	let { model, displayParts, fake_advice } = data;
	pros = data.pros;
	methods = data.methods;
	ProPhases = data.ProPhases;
	DataProDetail = data.DataProDetail;

	ruleData = model;
	ReferenceData.DisplayParts = displayParts;
	ReferenceData.ballistic = !!data.ballistic;
	ReferenceData.fake_advice = fake_advice || "";
	calculateRuleData();

	avgParts = {};
	avgPartsMap = {};
	[
		{ type: 1, typeName: "1W", field: "mesure_model" },
		{ type: 3, typeName: "5W", field: "mesure_model_5wood" },
		{ type: 10, typeName: "7I", field: "mesure_model_7iron" },
		{ type: 15, typeName: "PW", field: "mesure_model_pw" },
	].map((info) => {
		let data = [];
		let dataMap = {};
		let dataReverseMap = {};
		ReferenceData.RuleData["0003_AIGIA_Method(Myself)"][info.field].forEach(
			(m) => {
				data.push({
					idx: data.length + 1,
					part: m.part,
					field: m.formular_type,
				});
				dataMap[m.part] = m.formular_type;
				dataReverseMap[m.formular_type] = m.part;
			}
		);

		smParts.forEach((p) => {
			if (!data.find((x) => x.field == p)) {
				data.push({
					idx: data.length + 1,
					part: p,
					field: p,
				});
				dataMap[p] = p;
				dataReverseMap[p] = p;
			}
		});
		avgParts[info.type] = data;
		avgPartsMap[info.type] = dataMap;
		avgPartsReverseMap[info.type] = dataReverseMap;
	});

	console.log("update Model done");
};

const getDisplayPart = () => {
	return ReferenceData.DisplayParts;
};

const getReferenceData = () => {
	return ReferenceData;
};

const getAvgParts = () => {
	return avgParts;
};

const getAvgPartsMap = () => {
	return avgPartsMap;
};
const getAvgPartsReverseMap = () => {
	return avgPartsReverseMap;
};

const getSmParts = () => {
	return smParts.slice();
};

export {
	calculatePartByMesure,
	// ReferenceData,
	// DataProDetail,
	RuleData,
	mapData,
	updateModel,
	getDisplayPart,
	getReferenceData,
	getAvgParts,
	getSmParts,
	getAvgPartsMap,
	getAvgPartsReverseMap,
	// methods,
	// pros,
};
